// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preloader[data-v-f1531852]{margin-left:15px}.patient-name-title[data-v-f1531852]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:17px 10px;gap:10px}.patient-name-title h1[data-v-f1531852]{margin:0}.patient-name-title .summarize-button-wrapper[data-v-f1531852]{-ms-flex-line-pack:center;align-content:center}", ""]);
// Exports
module.exports = exports;
